@if (inline()) {
  <span class="match-detail-date-meta match-detail-date-meta--inline">
    <span class="match-detail-date-meta__date">{{ resolvedDateLabel() }}</span>
    <span class="match-detail-date-meta__separator">•</span>
    <span class="match-detail-date-meta__time">{{ timeLabel() }}</span>
  </span>
} @else {
  <div class="match-detail-date-meta">
    <span class="match-detail-date-meta__date">{{ resolvedDateLabel() }}</span>
    <span class="match-detail-date-meta__time">{{ timeLabel() }}</span>
  </div>
}
